import React from "react";
import {FINANCE} from "../../../config/resources";
import {useTranslation} from "react-i18next";


export function FinanceAmountCell({value, rowOriginal}){
    const {t} = useTranslation();
    let amount = parseFloat(value);
    switch(rowOriginal.type){
        case FINANCE.TYPE.REFUND:
            amount = <>
                <span className={`text-green-800`}>+${amount}</span>
            </>
            break;
        case FINANCE.TYPE.WITHDRAW:
            amount = <>
                <span className={`text-red-800`}>-${amount}</span>
                <small>
                    <div className={`font-light text-grey-500 text-xs`}>Will receive{` `}${rowOriginal.data?.will_receive}</div>
                    <div className={`font-light text-grey-500 text-xs -mt-1`}>Fee (1% + 1$){` `}${rowOriginal.data?.fee}</div>
                </small>
            </>
            break;
        case FINANCE.TYPE.TOPUP:
            if(rowOriginal.data?.paid_amount && parseFloat(rowOriginal.data?.paid_amount) !== parseFloat(amount)){
                amount = <>
                    <span className={`text-green-800`}>+${rowOriginal.data?.paid_amount}</span>
                    <span className={`font-light text-grey-500 line-through text-xs`}>${amount}</span>
                </>
            }else{
                amount = <span className={`text-green-800`}>+${amount}</span>
            }

            break;
        case FINANCE.TYPE.SUBSCRIPTION_RENEWAL:
        case FINANCE.TYPE.DOMAIN_REGISTER:
        case FINANCE.TYPE.APP_INSTALL:
            amount = <span className={`text-red-800`}>-${amount}</span>
            break;
        case FINANCE.TYPE.REFERRAL_BONUS_SUBSCRIPTION:
        case FINANCE.TYPE.REFERRAL_BONUS_INSTALL:
            if(rowOriginal.data?.hold_until_at && rowOriginal.data?.hold_until_at > new Date().toISOString().split('T')[0]){
                amount = <>
                    <span className={`font-bold`}>{t(`widget.latesttopups.in_hold`)} {rowOriginal.data.hold_until_at}</span>
                    <span className={`font-light text-grey-500 text-xs`}>${amount}</span>
                </>
            }else{
                amount = <span className={`text-green-800`}>+${amount}</span>
            }

            break;
    }
    return (
        <div className={`flex flex-col gap-1`}>
            {amount}
            {rowOriginal.balance_new && <small className={`font-light text-grey-500 `}>{t(`widget.latesttopups.balance`)}: {parseFloat(rowOriginal.balance_new)}</small>}
        </div>
    )
}
